import { Box, Stack } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import { styled, useTheme } from '@mui/material/styles';
// import AppBar from '@mui/material/AppBar';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { CloseOutlined } from '@ant-design/icons';

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: prop => prop !== 'open',
})(({ theme }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    variants: [
        {
            props: ({ open }) => open,
            style: {
                width: `calc(100% - ${drawerWidth - 16}px)`,
                transition: theme.transitions.create(['margin', 'width'], {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.enteringScreen,
                }),
                marginRight: drawerWidth,
            },
        },
    ],
}));

export const DialogActions = ({ children }) => {
    return <>{children}</>;
};
export default function MissionFullScreenDialog({
    children,
    toolbarChildren,
    title,
    open,
    onClose,
    actions,
    maxWidth = '100%',
    toolbar,
    openDrawer,
}) {
    const theme = useTheme();

    return (
        <Dialog fullScreen open={open} onClose={onClose}>
            <AppBar
                position="sticky"
                open={openDrawer}
                sx={{
                    boxShadow: 'none',
                    borderBottom: `1px solid ${theme.palette.grey.A800}`,
                }}
                color="inherit"
            >
                {!toolbar ? (
                    <Toolbar>
                        <Box sx={{ width: '100%' }}>
                            <Stack
                                direction={{ xs: 'row', sm: 'row' }}
                                alignItems={{ xs: 'center' }}
                                justifyContent={'space-between'}
                                spacing={1}
                            >
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                    }}
                                >
                                    <IconButton
                                        edge="start"
                                        color="inherit"
                                        onClick={onClose}
                                        aria-label="close"
                                    >
                                        <CloseOutlined />
                                    </IconButton>
                                    <Typography variant="h6" component="div">
                                        {title}
                                    </Typography>
                                </Box>
                                {!!toolbarChildren && toolbarChildren}
                            </Stack>
                        </Box>
                    </Toolbar>
                ) : (
                    toolbar
                )}
            </AppBar>
            <Box
                sx={{
                    width: '100%',
                    // maxWidth: '100%',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignSelf: 'center',
                    flexGrow: 1,
                    // p: { xs: 2, sm: 3 },
                }}
            >
                {children}
                {/* <Stack
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        margin: '20px 0',
                    }}
                    direction="row"
                    spacing={3}
                >
                    {actions}
                </Stack> */}
            </Box>
        </Dialog>
    );
}
